'use client';

import {isBrowser} from '@/lib/utils/page.utils';
import {useEffect, useState} from 'react';
import {UAParser} from 'ua-parser-js';

/**
 * Returns true if user agent is determined to be a Mac device
 */
export const useIsMac = (): boolean => {
	const [isMac, setIsMac] = useState(false);
	useEffect(() => {
		if (isBrowser()) {
			const parser = new UAParser();
			const os = parser.getOS();
			const isMacOS = os.name === 'Mac OS';
			setIsMac(isMacOS);
		}
	}, []);
	return isMac;
};

/**
 * Returns true if user agent is determined to be a mobile device
 */
export const useIsMobile = (): boolean => {
	const [isMobile, setIsMobile] = useState(false);
	useEffect(() => {
		if (isBrowser()) {
			const parser = new UAParser();
			const device = parser.getDevice();
			const isMobileDevice = device.type === 'mobile' || device.type === 'tablet';
			setIsMobile(isMobileDevice);
		}
	}, []);
	return isMobile;
};
